import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";

export async function clearAmplifyKeysLocally(): Promise<void> {
  try {
    await cognitoUserPoolsTokenProvider.tokenOrchestrator.clearTokens();
  } catch (error) {
    console.warn("[amplifyKeys] clearTokens failed", error);
  }
}
